import { useState, memo, type FC, useCallback } from 'react';
import { useDeleteChat, useReadChats } from '@hooks/apollo/chat';
import ContextMenu from '@components/context';
import SidebarChatItem from './sidebar-item';

interface ChatSidebarProps {
  setChatId: (id: number | null) => void;
  isCollapsed: boolean;
  chatId: number | null;
}

const ChatSidebarComponent: FC<ChatSidebarProps> = ({ setChatId, isCollapsed, chatId }) => {
  const [contextMenu, setContextMenu] = useState<{ x: number; y: number; chatId: number } | null>(
    null,
  );
  const { chats } = useReadChats();
  const { deleteChat } = useDeleteChat();

  const handleSelect = useCallback(
    (id: number) => {
      setChatId(id);
    },
    [setChatId],
  );

  const handleContextMenu = useCallback((e: React.MouseEvent, contextChatId: number) => {
    e.preventDefault();
    setContextMenu({ x: e.clientX, y: e.clientY, chatId: contextChatId });
  }, []);

  const handleDeleteAndClose = useCallback(() => {
    if (contextMenu) {
      deleteChat(contextMenu.chatId);
      if (chatId === contextMenu.chatId) {
        setChatId(null);
      }
      setContextMenu(null);
    }
  }, [contextMenu, deleteChat, setChatId, chatId]);

  return (
    <>
      {chats.map((shallowChat) => (
        <SidebarChatItem
          key={shallowChat.id}
          id={shallowChat.id}
          selected={chatId === shallowChat.id}
          isCollapsed={isCollapsed}
          onClick={handleSelect}
          onContextMenu={handleContextMenu}
        />
      ))}

      {contextMenu && (
        <ContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          onDelete={handleDeleteAndClose}
          onClose={() => setContextMenu(null)}
        />
      )}
    </>
  );
};

ChatSidebarComponent.displayName = 'ChatSidebar';

export const ChatSidebar = memo(ChatSidebarComponent);
